/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { change, Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import AsyncSelect from 'react-select/async';
import {
  TextField,
  Typography,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Paper,
} from '@material-ui/core';
import { defineMessages, injectIntl } from 'react-intl';
import { getFlagWithText } from '../../../../helpers/flagDisplay';
import teacherServices from '../../../../redux/services/teacherServices';
import resourceServices from '../../../../redux/services/resourceServices';
import googleStorageServices from '../../../../redux/services/googleStorageServices';
// import SidebarComment from '../CommentSidebar';
import AddZoomFile from './AddZoomFile';
import FilesList from './FilesList';
import AddStudents from './AddStudents';

const messages = defineMessages({
  language: {
    id: 'CoursePlan.language',
    defaultMessage: 'Language',
  },
  title: {
    id: 'Group.title',
    defaultMessage: 'Group creation',
  },
  name: {
    id: 'Group.name',
    defaultMessage: 'Group name',
  },
  type: {
    id: 'Group.type',
    defaultMessage: 'Group type',
  },
  level: {
    id: 'Group.level',
    defaultMessage: 'Group level',
  },
  teacher: {
    id: 'Group.teacher',
    defaultMessage: 'Group teacher',
  },
});

const customStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '56px',
    marginTop: '10px',
    fontSize: '16px',
    boxShadow: state.isFocused ? '0 0 0 1px #002984' : 0,
  }),
};

const reactSelectStyles = {
  control: (base) => ({
    ...base,
    zIndex: 999,
  }),
};

const required = (value) => (value ? undefined : 'Required');

function getOptions(query, callback) {
  teacherServices.getAll().then((data) => {
    data.sort((a, b) => b.value < a.value);
    const tmp = [];
    if (query.length === 0) {
      data.forEach((element) => {
        tmp.push({ label: element.label, value: element.id, id: element.id });
      });
    } else {
      const newArr = data.filter((item) => item.label.toLowerCase().includes(query.toLowerCase()));
      newArr.forEach((element) => {
        tmp.push({ label: element.label, value: element.id, id: element.id });
      });
    }
    callback(tmp);
  });
}

function fetchLanguageOptions(query, callback) {
  resourceServices.getLanguage()
    .then((data) => {
      const tempArray = [];
      data.sort((a, b) => b.name < a.name);
      if (query.length === 0) {
        data.forEach((element) => {
          const itemWithFlag = getFlagWithText(element);
          tempArray.push({
            label: itemWithFlag, value: element._id, name: element.name, initial: element.initial,
          });
        });
      } else {
        const newArr = data.filter((item) => item.name.toLowerCase().includes(query.toLowerCase()));
        newArr.forEach((element) => {
          const itemWithFlag = getFlagWithText(element);
          tempArray.push({
            label: itemWithFlag, value: element._id, name: element.name, initial: element.initial,
          });
        });
      }
      callback(tempArray);
    })
    .catch(() => {});
}

const renderTextField = ({
  input,
  label,
  ...custom
}) => (
  <div>
    <TextField label={label} {...input} {...custom} />
  </div>
);

const renderSelectField = ({
  input,
  label,
  children,
  ...custom
}) => (
  <div styles={{ width: '100%' }}>
    <Select
      native
      {...input}
      {...custom}
      inputProps={{
        name: 'groupType',
        id: 'group-type',
      }}
      input={(
        <OutlinedInput
          name="groupType"
          labelWidth={110}
          id="groupType-select"
        />
        )}
    >
      <option value="" />
      <option value="EW">English World</option>
      <option value="MW">Medical World</option>
      <option value="Coaching">Impact Coaching</option>
    </Select>
  </div>
);

const renderLevelSelectField = ({
  input,
  label,
  children,
  ...custom
}) => (
  <div>
    <Select
      native
      {...input}
      {...custom}
      inputProps={{
        name: 'level',
        id: 'level',
      }}
      input={
        <OutlinedInput name="level" labelWidth={110} id="level-select" />
        }
    >
      <option value="0">Débutant/Beginner</option>
      <option value="1">A1</option>
      <option value="2">A2</option>
      <option value="3">B1</option>
      <option value="4">B2</option>
      <option value="5">C1</option>
      <option value="6">C2</option>
    </Select>
  </div>
);

const renderAsyncSelectField = ({
  input,
  label,
  ...custom
}) => (
  <div>
    <AsyncSelect
      {...input}
      {...custom}
      isMulti
      cacheOptions
      styles={customStyles}
      onChange={(value) => input.onChange(value)}
      defaultOptions
      loadOptions={(query, callback) => getOptions(query, callback)}
      classNamePrefix="react-Selector"
      onBlur={() => input.onBlur(input.value)}
    />
  </div>
);

const renderSelectFieldLanguage = ({
  input,
  label,
  children,
  ...custom
}) => (
  <div>
    <AsyncSelect
      {...input}
      {...custom}
      cacheOptions
      styles={customStyles}
      onChange={(value) => input.onChange(value)}
      defaultOptions
      loadOptions={(query, callback) => fetchLanguageOptions(query, callback)}
      classNamePrefix="react-Selector"
      onBlur={() => input.onBlur(input.value)}
    />
  </div>
);

const GroupCreation = (props) => {
  const { intl } = props;
  const { company } = props.company;
  const { group } = props;
  const parseUrl = queryString.parse(props.location.search);
  const [filesList, setFilesList] = useState([]);

  const getFilesFromStorage = async () => {
    const files = await googleStorageServices.getFiles('zoom_link', company.name, group.name);
    setFilesList(files.data[0]);
  };

  useEffect(() => {
    const { dataform } = props;
    if (dataform && dataform.values && dataform.values.language && dataform.values.language.label) {
      props.dispatch(change(`${props.form}`, 'language', dataform.values.language));
    } else if (props.initialValues && props.initialValues.language) {
      props.dispatch(change(`${props.form}`, 'language', {
        label: getFlagWithText(props.initialValues.language),
        value: props.initialValues.language._id,
        name: props.initialValues.language.name,
        initial: props.initialValues.language.initial,
      }));
    }
  }, []);

  return (
    <>
      <Container className="group-creation-container-centered">
        <Col className="group-creation-card">
          {/* <SidebarComment /> */}
          <h3>{intl.formatMessage(messages.title)}</h3>
          <Row>
            <Col md={6}>
              <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
                {intl.formatMessage(messages.name)}
              </Typography>
              <Field
                validate={[required]}
                name="name"
                label={intl.formatMessage(messages.name)}
                style={{ width: '100%' }}
                id="outlined-uncontrolled"
                variant="outlined"
                component={renderTextField}
              />
            </Col>
            <Col md={6}>
              <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
                {intl.formatMessage(messages.type)}
              </Typography>
              <FormControl style={{ width: '100%' }} variant="outlined">
                <InputLabel htmlFor="group-type">
                  {intl.formatMessage(messages.type)}
                </InputLabel>
                <Field
                  style={{ width: '100%' }}
                  name="type"
                  validate={[required]}
                  component={renderSelectField}
                  label="Group Type"
                />
              </FormControl>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Typography style={{ marginTop: '10px', marginBottom: '10px' }}>
                Level (leave blank to generate both lv1 & 2)
              </Typography>
              <FormControl style={{ width: '100%' }} variant="outlined">
                <InputLabel htmlFor="group-type">
                  {intl.formatMessage(messages.level)}
                </InputLabel>
                <Field
                  name="level"
                  validate={[required]}
                  style={{ width: '100%' }}
                  component={renderLevelSelectField}
                  label={intl.formatMessage(messages.level)}
                />
              </FormControl>
            </Col>
            <Col md={6}>
              <Typography style={{ marginTop: '10px' }}>
                {intl.formatMessage(messages.teacher)}
              </Typography>
              <Field
                style={{ width: '100%' }}
                name="idTeachers"
                validate={[required]}
                component={renderAsyncSelectField}
                type="select"
                label="Teacher"
              />
            </Col>
            <Col md={6}>
              <Typography style={{ marginTop: '10px' }}>
                {intl.formatMessage(messages.language)}
              </Typography>
              <FormControl variant="outlined" style={{ width: '100%' }}>
                <Field
                  name="language"
                  component={renderSelectFieldLanguage}
                  validate={[required]}
                  label="language-select"
                  styles={reactSelectStyles}
                />
              </FormControl>
            </Col>
          </Row>
        </Col>
      </Container>
      {parseUrl.update === 'true' && company.type === '2'
      && (
      <Paper
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: '30px',
          margin: '0px 15px 0px 15px',
        }}
        elevation={1}
      >
        <Typography variant="h6" style={{ marginBottom: '20px' }}>Adding groups for zoom</Typography>
        <AddZoomFile
          company={company}
          group={group}
          getFilesFromStorage={getFilesFromStorage}
        />
        <FilesList
          company={company}
          group={group}
          getFilesFromStorage={getFilesFromStorage}
          filesList={filesList}
        />
      </Paper>
      )}
      {parseUrl.update === 'true' && company.type === '1'
        && <AddStudents />}
    </>
  );
};

GroupCreation.propTypes = {
  dataform: PropTypes.any.isRequired,
  form: PropTypes.any.isRequired,
  initialValues: PropTypes.any.isRequired,
  dispatch: PropTypes.any.isRequired,
  intl: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const name = `group_${state.group.selectedGroup._id}`;
  const { company } = state;
  const group = state.group.selectedGroup;
  const dataform = state.form[`group_${state.group.selectedGroup._id}`];
  return {
    initialValues: state.group.selectedGroup, form: name, dataform, company, group,
  };
}

const connectedGroupForm = reduxForm({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
})(GroupCreation);

const NewconnectedGroupForm = connect(
  mapStateToProps,
  {},
)(injectIntl(connectedGroupForm));

export default NewconnectedGroupForm;
